import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getAppointmentTimeslotsRequest: ["categoryId"],
  getAppointmentTimeslotsSuccess: ["timeslots"],
  getAppointmentTimeslotsFailure: null,
});

export const GetAppointmentTimeslotsTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  categoryId: null,
  fetching: null,
  success: null,
  timeslots: null,
  error: null,
});

export const GetAppointmentTimeslotsSelectors = {
  getData: (state: any) => state.getAppointmentTimeslots.data,
  isFetching: (state: any) => state.getAppointmentTimeslots.fetching,
  isSuccess: (state: any) => state.getAppointmentTimeslots.success,
  hasError: (state: any) => state.getAppointmentTimeslots.error,
};

export const request = (state: any, { categoryId }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    categoryId,
    timeslots: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { timeslots } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    timeslots,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    timeslots: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_APPOINTMENT_TIMESLOTS_REQUEST]: request,
  [Types.GET_APPOINTMENT_TIMESLOTS_SUCCESS]: success,
  [Types.GET_APPOINTMENT_TIMESLOTS_FAILURE]: failure,
});
